import config from '@/utils/appConfig'

export const integrationsApiBaseUrl = config.VUE_APP_API_USERS_URL

export function getCatalogErrorMessage(error) {
  const body = error?.response?.data
  const code = body?.error || body?.data?.error
  if (code === 'INTEGRATIONS_CATALOG_UNAVAILABLE') {
    return 'Integrations catalog is temporarily unavailable'
  }
  if (code === 'INTEGRATION_NOT_FOUND') {
    return 'Integration not found'
  }
  return error?.message || 'Failed to load integrations'
}
